import React, { createContext, useState, useEffect } from 'react';
import * as Storage from '../utilities/storage'

export const ThemeContext = createContext({
  isDarkTheme: false,
  toggleTheme: () => {},
});

const ThemeProvider = ({ children }) => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    if (Storage.get('theme') === 'dark') {
      setIsDarkTheme(true);
    } else {
      setIsDarkTheme(false);
    }
  }, [setIsDarkTheme]);

  const toggleTheme = () => {
    if (isDarkTheme) {
      Storage.set('theme', 'light');
    } else {
      Storage.set('theme', 'dark')
    }
    setIsDarkTheme(!isDarkTheme);
  };

  return (
    <ThemeContext.Provider value={{ isDarkTheme, toggleTheme }}>{children}</ThemeContext.Provider>
  );
};

export default ThemeProvider;
